import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'src/lib/ComponentProps';

import { FieldEditFrame } from 'src/utils/customFieldEditFrame';
import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import BookIcon from 'public/icons/BookTicked.svg';

import styles from './ResourceSubjectGuides.module.css';

type SubjectGuide = {
	fields: {
		Title: Field<string>;
	};
	url: string;
};

type SubjectGuidesProps = ComponentProps & {
	fields: {
		Heading: Field<string>;
		Description: Field<string>;
		LinkText: Field<string>;
		SubjectGuides: SubjectGuide[];
		DatasourceId: string;
	};
};

export default function SubjectGuides(props: SubjectGuidesProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && (!props.fields?.SubjectGuides || props.fields.SubjectGuides.length < 1)) {
		return <></>;
	}

	return (
		<section className={'maxWidth padX'}>
			<Text tag="h3" field={props.fields?.Heading} />

			<Text className={styles.description} tag="p" field={props.fields?.Description} />

			{props.fields && (
				<FieldEditFrame itemId={props.fields.DatasourceId} fields={['SubjectGuides']} header="Select Subject Guides">
					<EditorHelp text="Click here to change which subject guides appear" />
					<div className={styles.signPostGrid}>
						{props.fields.SubjectGuides.filter((subjectGuide) => subjectGuide).map((subjectGuide: SubjectGuide, index: number) => (
							<div className={`${styles.signPost} shadow`} key={index}>
								<div className={styles.signPostHeader}>
									<Text tag="h3" className={styles.heading} field={subjectGuide.fields?.Title} />

									{subjectGuide.url && props.fields?.LinkText?.value && (
										<a href={subjectGuide.url} target="_blank" rel="noreferrer">
											{props.fields.LinkText.value}
										</a>
									)}
								</div>

								<span className={styles.icon}>
									<BookIcon className={styles.svg} />
								</span>
							</div>
						))}
					</div>
				</FieldEditFrame>
			)}
		</section>
	);
}
